import React from 'react'

export default function Warning() {
    return (
        <div>
            <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.71036 64.3097L32.0429 2.18869C32.9232 0.385781 35.4841 0.361719 36.3981 2.14781L68.1866 64.2688C69.0156 65.8888 67.839 67.8126 66.0192 67.8126H3.89813C2.09836 67.8126 0.920669 65.9271 1.71036 64.3097Z" fill="black" />
                <path d="M38.8735 23.6525L37.208 46.0057C37.0835 47.6782 35.6266 48.933 33.9541 48.8083C32.4344 48.6951 31.26 47.4812 31.1515 46.0057L29.4859 23.6525C29.2927 21.0601 31.2377 18.802 33.83 18.6089C36.4223 18.4159 38.6805 20.3607 38.8735 22.953C38.8905 23.1802 38.8884 23.4315 38.8735 23.6525ZM34.1797 53.5765C31.7964 53.5765 29.8643 55.5085 29.8643 57.8919C29.8643 60.2752 31.7964 62.2072 34.1797 62.2072C36.563 62.2072 38.4951 60.2752 38.4951 57.8918C38.4951 55.5085 36.563 53.5765 34.1797 53.5765Z" fill="white" />
            </svg>

        </div>
    )
}
